var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper fixed",staticStyle:{"height":"100%","width":"100%"}},[_c('transition',{attrs:{"mode":"out-in","enter-active-class":"fadeIn","leave-active-class":"fadeOut","appear":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }